/* tslint:disable */
/* eslint-disable */
/**
 * Swipe4Work Employer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the JobFunctionCrudJobFunctionDto interface.
 */
export function instanceOfJobFunctionCrudJobFunctionDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('jobCategoryId' in value) || value['jobCategoryId'] === undefined)
        return false;
    return true;
}
export function JobFunctionCrudJobFunctionDtoFromJSON(json) {
    return JobFunctionCrudJobFunctionDtoFromJSONTyped(json, false);
}
export function JobFunctionCrudJobFunctionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
        'jobCategoryId': json['jobCategoryId'],
    };
}
export function JobFunctionCrudJobFunctionDtoToJSON(json) {
    return JobFunctionCrudJobFunctionDtoToJSONTyped(json, false);
}
export function JobFunctionCrudJobFunctionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
        'jobCategoryId': value['jobCategoryId'],
    };
}
